
import {
    PurchasedStocksAction,
    PurchasedStocksState,
    ADD_PURCHASED_STOCK,
    SET_PURCHASED_STOCKS,
    CLEAR_PURCHASED_STOCKS,
    REMOVE_PURCHASED_STOCK,
} from './types';

const initialState: PurchasedStocksState = {
    value: [],
    momentum: [],
};

const PurchasedStocks = (
    state = initialState,
    action: PurchasedStocksAction
): PurchasedStocksState => {
    switch (action.type) {
        case ADD_PURCHASED_STOCK:
            const { strategy, stock } = action.payload;
            const existingStocks = state[strategy];
            const index = existingStocks.findIndex(s => s.symbol === stock.symbol);
            let updatedStocks;

            if (index !== -1) {
              
                const existing = existingStocks[index];
                 
                const updatedStock = {
                    ...existing,
                    quantity: existing.quantity + stock.quantity,
                    total: (existing.total + stock.total),
                    price: stock.price,
                    tradeId: stock.tradeId,
                };

                updatedStocks = [...existingStocks];
                updatedStocks[index] = updatedStock;
            } else {
                updatedStocks = [...existingStocks, stock];
            }

            return {
                ...state,
                [strategy]: updatedStocks,
            };

        case SET_PURCHASED_STOCKS:
            return {
                ...state,
                [action.payload.strategy]: action.payload.stocks,
            };

        case CLEAR_PURCHASED_STOCKS:
            return {
                ...state,
                [action.payload.strategy]: [],
            };

        case REMOVE_PURCHASED_STOCK:
            return {
                ...state,
                [action.payload.strategy]: state[action.payload.strategy].filter(
                    (stock) => stock.symbol !== action.payload.symbol
                ),
            };

        default:
            return state;
    }
};

export default PurchasedStocks;
